import React from 'react';
import './SecuritySettingsRow.scss';

interface SecuritySettingsRowProps {
  name: string;
  title: string;
  rightElement?: React.ReactNode;
  onPress?: (name: string) => void;
}

const SecuritySettingsRow = ({ name, title, onPress, rightElement }: SecuritySettingsRowProps) => {
  const handlePress = () => {
    onPress?.(name);
  };

  return (
    <button onClick={handlePress} className='security-settings-row'>
      <span className='security-settings-row__title'>{title}</span>
      {rightElement ? (
        rightElement
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
        >
          <path
            d='M9.5 18L15.5 12L9.5 6'
            stroke='#344054'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
    </button>
  );
};

export default SecuritySettingsRow;
